import { useEffect, useState } from 'react';
import {
  TextField
} from '@mui/material';


export const NoteField = (props) => {
  const { onChange, original_value } = props
  const [ value, setValue ] = useState(original_value || "")

  useEffect(() => {
    setValue(original_value)
  }, [original_value])


  return (
    <TextField
      sx={{width: '100%'}}
      multiline
      variant='standard'
      label="Note"
      value={value}
      onChange={(e) => { 
        if (onChange) { onChange(e.target.value) }
        setValue(e.target.value) 
      }}
    />
  )
}